// App top bar look. Class names are written out in full so Tailwind can see them.
// The AdAudit logo on the left; New search, Audits and Sign out live
// behind the menu button on the right.
export const TOP_BAR = {
  bar: "bg-white border-b border-slate-200 shrink-0",
  inner: "flex items-center justify-between",
  innerFull: "px-5 py-2",
  innerCentred: "max-w-6xl mx-auto px-6 py-3",
  // The AdAudit logo image: about 22px tall at the 110% app scale (in rem so it scales).
  logo: "h-[1.25rem] w-auto shrink-0 select-none",
  // Right-hand side: the account name, then the menu button.
  right: "flex items-center gap-2",
  // The signed-in account's name, small and quiet.
  account: "text-xs font-medium text-slate-500 truncate max-w-[12rem]",
  // Just the three lines, in the toned-back purple (no filled button); a soft
  // purple background only on hover or while the menu is open.
  menuButton: "w-9 h-9 flex items-center justify-center rounded-lg hover:bg-violet-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-200 aria-expanded:bg-violet-50",
  menuIcon: "flex flex-col gap-[0.25rem]",
  menuLine: "block w-5 h-0.5 rounded-full bg-violet-400",
  // Above the report's menus and maps (z 1000) and its expanded panels.
  menuPanel: "absolute right-0 top-full mt-2 z-[1100] w-48 bg-white border border-slate-200 rounded-lg shadow-lg py-1",
  menuItem: "w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-violet-50",
  menuItemActive: "w-full text-left px-3 py-2 text-sm font-semibold text-violet-900 bg-violet-100",
  menuItemMuted: "w-full text-left px-3 py-2 text-sm text-slate-500 hover:bg-violet-50 hover:text-slate-800",
  menuDivider: "border-t border-slate-100 my-1",
};
